import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import MapComponent from "./MapComponent";
import SeccionDocumentos from "./seccion-datos-documentos";
import SeccionDatosTematica from "./seccion-datos-tematica";
import BloqueEstadistica from "../vista-regiones/bloque-estadisticas";
import SeccionCabecera from "./seccion-cabecera-filtro";
import SiniaCustomChart from "../../components/charts/sinia-custom-chart.component";
import { DataService } from "../../services/data.service";
import ChartUtils from "../../commons/chart-utils.module";
import IndicadoresAmbientales from "../../commons/indicadores.module";
import Ubigeo from "../../commons/ubigeo.module";
import LayersUtils from "./LayersUtils";
import StringUtils from "../../commons/string-utils.module";
import MapLegend from "../vista-mapas/map-legend";
import SVGIcon from "../../components/Utils/svgIcons";
import { getNombreTematica } from "../../data/tematicas.data";

import "./carousel.css"; // requires a loader
import "./index.scss";
const DEFAULT_REGION_CODE = "00";
const DEFAULT_TEMATICA_CODE = "04";

class VistaTematicasAmbientales extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    VistaTematicasAmbientales.instanceCount++;
    let me = this;
    me.instanceId = VistaTematicasAmbientales.instanceCount;
    me.urlParams = StringUtils.getUrlParams(props.location.search);
    this.state = {
      ubigeo: me.getCodigoRegionInicial(),
      marco: me.getCodigoTematicaInicial(),
      periodo: 2019,
      data_documento: [],
      data_norma: [],
      indicadores_store: [],
      indicadores_store_info: [],
      col_size_default: 6,
      showLayer: true,
      dataLayer: [],
      listLayer: [],
      dataLegend: [],
      showLegend: false,
      md_col_size: 6,
      showMenuLeft: true,
      activeTab: "1",
      currentItem: {},
      data_estadistica: [],
      availableStore: false,
    };
    this.onChangeUbigeo = this.onChangeUbigeo.bind(this);
    this.onChangeMarco = this.onChangeMarco.bind(this);
    this.onChangeColSize = this.onChangeColSize.bind(this);
    this.handleClickLayerToogle = this.handleClickLayerToogle.bind(this);
    this.handleClickLayer = this.handleClickLayer.bind(this);
    this.handleClickLayerLegend = this.handleClickLayerLegend.bind(this);
    this.handleClickMenuLeft = this.handleClickMenuLeft.bind(this);
  }
  componentDidMount() {
    let me = this;
    me.mounted = true;
    IndicadoresAmbientales.formatRawData(function(indicadores) {
      me.setState(
        {
          availableStore: true,
        },
        () => me.getIndicadoresByTematica(me.state.marco)
      );
    });
  }
  componentWillUnmount() {
    let me = this;
    me.mounted = false;
  }
  getMapLegendId() {
    return "map-tematica-legend-" + this.instanceId;
  }
  /**
   * Devuelve el codigo de región desde la URL actual
   *
   * @returns {string} Código de región
   */
  getCodigoRegionInicial() {
    return this.urlParams.region || DEFAULT_REGION_CODE;
  }
  /**
   * Devuelve el codigo de región desde la URL actual
   *
   * @returns {string} Código de región
   */
  getCodigoTematicaInicial() {
    return this.urlParams.tematica || DEFAULT_TEMATICA_CODE;
  }
  /**
   *
   * @param {Array} marco_indicadores
   */
  crearReferencias(marco_indicadores) {
    let me = this;
    if (marco_indicadores.length > 0) {
      marco_indicadores.forEach((item) => {
        me["ref" + item.id] = React.createRef();
      });
    }
  }
  /**
   *
   * @param {String} ubigeo
   * @param {String} marco
   * @param {String} periodo
   */
  processingData(ubigeo, marco, periodo) {
    let me = this;
    /**
     * Seccion Documentos y Normas
     */
    DataService.getData(
      {
        query: "SNA04",
        ubigeo: ubigeo,
        marco: marco,
        pnum: 0,
        psize: 3,
      },
      function(result) {
        if (me.mounted)
          me.setState({
            data_documento: result.SNA04.data,
          });
      }
    );
    DataService.getData(
      {
        query: "SNA05",
        ubigeo: ubigeo,
        marco: marco,
        pnum: 0,
        psize: 3,
      },
      function(result) {
        if (me.mounted)
          me.setState({
            data_norma: result.SNA05.data,
          });
      }
    );
    this.setState({
      ubigeo: ubigeo,
      marco: marco,
      data_documento: [],
      data_norma: [],
    });
  }
  handleClickLayerLegend(e) {
    e.preventDefault();
    let isVisible = this.state.showLegend;
    isVisible = !isVisible;
    this.setState({
      showLegend: isVisible,
    });
  }
  handleClickMenuLeft(e) {
    e.preventDefault();
    let isVisible = this.state.showMenuLeft;
    isVisible = !isVisible;
    this.setState({
      showLegend: !isVisible,
      showMenuLeft: isVisible,
      md_col_size: isVisible ? 6 : 12,
    });
  }
  getIndicadoresByTematica(marco) {
    let me = this;
    let data_indicadores = [];
    let data_indicadores_info = [];
    let indicador_source = IndicadoresAmbientales.getIndicadoresPorTematica(
      marco
    );
    for (const key in indicador_source) {
      const object = indicador_source[key];
      const element = object;
      data_indicadores.push(element);
      const item_info = {
        id: object.id,
        icon: "icon-indicadores",
        title: object.nombre,
        simbol: object.unidad_sigla,
        value: "",
        periodo: "",
      };
      data_indicadores_info.push(item_info);
    }
    me.crearReferencias(data_indicadores);
    me.setState(
      {
        indicadores_store: data_indicadores,
        indicadores_store_info: data_indicadores_info,
        dataLayer: [],
        marco: marco,
      },
      () => me.onLoadingDataRemote(data_indicadores)
    );
    me.loadLayerMap(marco);
    /**
     * Load documentos y normas
     */
    me.processingData(me.state.ubigeo, me.state.marco, me.state.periodo);
  }
  /**
   *
   * @param {Array} ubigeo
   */
  onChangeUbigeo(ubigeo) {
    let me = this;
    me.processingData(ubigeo, me.state.marco, me.state.periodo);
    me.resetDatosWidget();
    me.setState({ ubigeo: ubigeo }, () =>
      me.onLoadingDataRemote(me.state.indicadores_store)
    );
  }
  /**
   *
   * @param {String} marco
   */
  onChangeMarco(marco) {
    let me = this;
    me.setState({ marco: marco }, () => me.getIndicadoresByTematica(marco));
  }
  /**
   *
   * @param {Array} periodo
   */
  onChangePeriodo(periodo) {
    this.processingData(this.state.ubigeo, this.state.marco, periodo[0].value);
  }
  /**
   *
   * @param {Array} marco_indicadores
   */
  onLoadingDataRemote(marco_indicadores) {
    var me = this;
    if (marco_indicadores.length > 0) {
      marco_indicadores.forEach(function(item, i) {
        me.cargarDatos(item.id);
      });
    }
    //var me = this;
    //me.cargarDatos(marco_indicadores.id);
  }
  /**
   *
   * @param {string} idIndicador
   * @param {RefObject} referencia
   */
  renderChart(idIndicador, type = "bar") {
    let titleTpl = `${IndicadoresAmbientales.getNombre(idIndicador)}`;
    return (
      <SiniaCustomChart
        exportable={true}
        chartType={type}
        titleTpl={titleTpl}
        yAxeTitle={IndicadoresAmbientales.getUnidad(idIndicador)}
        seriesLabel={IndicadoresAmbientales.getUnidad(idIndicador)}
        xAxeTitle="Años"
        source={`Fuente: ${IndicadoresAmbientales.getFuenteAbrev(idIndicador)}`}
        ref={this["ref" + idIndicador]}
      />
    );
  }
  /**
   *
   * @param {Int} idIndicador
   */
  cargarDatos(idIndicador) {
    var me = this,
      props = me.state;
    let serie = IndicadoresAmbientales.getSerie(idIndicador, props.ubigeo);
    if (serie) {
      DataService.getData(
        {
          query: "SNA08",
          ubigeo: props.ubigeo,
          marco: props.marco,
          serie: serie,
        },
        function(data) {
          if (me.mounted) {
            if (
              data.SNA08.data &&
              data.SNA08.data[0] &&
              data.SNA08.data[0].valor
            ) {
              let castedData = ChartUtils.formatYearlyDataForChart(
                data.SNA08.data
              );
              let lastData = ChartUtils.lastDataForChart(data.SNA08.data);
              //me.actualizarDatosDeGrafico(me.getChart(idIndicador), castedData);
              lastData.id = idIndicador;
              me.actualizarDatosWidget(lastData);
            } else {
              let castedData = ChartUtils.formatYearlyDataForChart([]);
              let lastData = ChartUtils.lastDataForChart([]);
              //me.actualizarDatosDeGrafico(me.getChart(idIndicador), castedData);
              lastData.id = idIndicador;
              me.actualizarDatosWidget(lastData);
            }
          }
        }
      );
    } else {
      let castedData = ChartUtils.formatYearlyDataForChart([]);
      let lastData = ChartUtils.lastDataForChart([]);
      //me.actualizarDatosDeGrafico(me.getChart(idIndicador), castedData);
      lastData.id = idIndicador;
      me.actualizarDatosWidget(lastData);
    }
  }
  getChart(idIndicador) {
    return this["ref" + idIndicador].current;
  }
  /**
   *
   * @param {SiniaCustomChart} chart
   * @param {object} datos
   * @param {array} data.valores
   * @param {array} data.categorias
   */
  actualizarDatosDeGrafico(chart, datos) {
    if (chart && chart.actualizarDatos) {
      chart.actualizarDatos(datos.valores, datos.categorias, {
        region: Ubigeo.getNombreRegion(this.state.ubigeo),
        anioInicio: datos.anioInicio,
        anioFin: datos.anioFin,
        unidad: "Hectareas",
      });
    }
  }
  /**
   *
   * @param {Object} chart
   * @param {Array} datos
   */
  actualizarDatosWidget(data) {
    let me = this;
    let new_indicadores_info = [];
    if (me.state.indicadores_store_info.length > 0) {
      me.state.indicadores_store_info.forEach(function(item, i) {
        if (item.id !== data.id) {
          new_indicadores_info.push(item);
        } else {
          let newitem = Object.assign({}, item);
          newitem.value = data.LastValor;
          newitem.periodo = data.LastPeriodo;
          new_indicadores_info.push(newitem);
        }
      });
      me.setState({
        indicadores_store_info: new_indicadores_info,
      });
    }
  }
  resetDatosWidget() {
    let me = this;
    let new_indicadores_info = [];
    if (me.state.indicadores_store_info.length > 0) {
      me.state.indicadores_store_info.forEach(function(item, i) {
        let newitem = Object.assign({}, item);
        newitem.value = "";
        newitem.periodo = "";
        new_indicadores_info.push(newitem);
      });
      me.setState({
        indicadores_store_info: new_indicadores_info,
      });
    }
  }
  onChangeColSize(e, size) {
    e.preventDefault();
    let me = this;
    this.setState({ col_size_default: size }, () => me.onChangeChartSize());
  }
  onChangeChartSize() {
    if (window.xchart && window.xchart.charts.length > 0) {
      window.xchart.charts.forEach(function(p, k) {
        if (p) p.reflow();
      });
    }
  }
  handleClickLayerToogle(e) {
    e.preventDefault();
    let isVisible = this.state.showLayer;
    isVisible = !isVisible;
    this.setState({
      showLayer: isVisible,
    });
  }
  handleClickLayer(event) {
    let me = this;
    let dataLayer = [
      {
        url: event.target.attributes.getNamedItem("url").value,
        visible:
          event.target.attributes.getNamedItem("visible").value === "true",
        layerName: event.target.attributes.getNamedItem("layer").value,
        type: event.target.attributes.getNamedItem("layertype").value,
        link: event.target.attributes.getNamedItem("link").value,
        label: event.target.attributes.getNamedItem("label").value,
        fuente: event.target.attributes.getNamedItem("fuente").value,
        id: event.target.id,
        checked: event.target.checked,
        init: false,
      },
    ];
    let new_store = [];
    let found = false;
    me.state.dataLegend.forEach((item) => {
      if (item.id == event.target.id) {
        new_store.push(event);
        found = true;
      } else {
        new_store.push(item);
      }
    });
    if (!found) {
      new_store.push(dataLayer[0]);
    }
    this.setState({
      dataLayer: dataLayer,
      dataLegend: new_store,
    });
  }
  loadLayerMap(marco) {
    let me = this;
    LayersUtils.getLayers(marco, function(data) {
      if (data.child) {
        me.setState({
          listLayer: data.child,
          dataLegend: [],
        });
      } else {
        me.setState({
          listLayer: [],
          dataLegend: [],
        });
      }
    });
  }
  render() {
    let me = this;
    const {
      indicadores_store,
      indicadores_store_info,
      ubigeo,
      data_norma,
      marco,
      data_documento,
      col_size_default,
      showLayer,
      dataLayer,
      listLayer,
      showLegend,
      dataLegend,
      showMenuLeft,
      md_col_size,
      currentItem,
      data_estadistica,
      availableStore,
    } = this.state;
    let instanceLegendMap = me.getMapLegendId();
    let tematicaNombre = getNombreTematica(marco);
    return (
      <div>
        <Row className="mb-3">
          <Col xs={12} sm={12} md={11} xl={1}>
            <div  className="block-image-tematica">
            <img
              src={`imagenes/tematicas/v2/${marco}.png`}
            />
            </div>
          </Col>
          <Col xs={12} sm={12} md={11} xl={11}>
          <div className="mt-4">
            </div>
            <div className="ml-4 block-image-tematica__title">
            <span>
              {tematicaNombre}
            </span>
            </div>
          </Col>
        </Row>
        <SeccionCabecera
          scope={me}
          ubigeo={ubigeo}
          marco={marco}
          onChangeMarco={this.onChangeMarco}
          onChangeUbigeo={this.onChangeUbigeo}
        />
        {/*<Row>
         <SeccionDatosTematica param={marco} data={indicadores_store_info} />
        </Row>*/}
        <Row>
          <Col xs={12} sm={7} md={9} xl={10}>
            <div className="text-primary">
              <span>
                <h5>Estadística ambiental</h5>
              </span>
            </div>
          </Col>
          <Col xs={12} sm={5} md={3} xl={2} className="mt-2 text-right">
            <NavLink key={this.props.marco} to={`./estadisticas`}>
              <i className="fas fa-plus" aria-hidden="true" />
              <span className="text-primary ml-1">Ver todos </span>
            </NavLink>
          </Col>
        </Row>
        <BloqueEstadistica
          availableStore={availableStore}
          idRegion={ubigeo}
          idTematica={marco}
        />
        <Row>
          <Col xs={12} sm={12} md={12} xl={12}>
            <Card className="card-border-line">
              <CardHeader className="card-header-boder-bottom-line">
                <Row>
                  <Col xs={12} sm={7} md={9} xl={9}>
                    <div className="h5 card-sinia__title_default">
                      <span>Información geoespacial</span>
                    </div>
                  </Col>
                  <Col xs={12} sm={5} md={3} xl={3} className="mt-2 text-right">
                    <NavLink
                      key={this.props.marco}
                      to={`./mapas`}
                    >
                      <i className="fas fa-plus" aria-hidden="true" />
                      <span className="text-primary ml-1">Ver todos{" "}</span>
                    </NavLink>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div id="viewDiv" className="map-component-view map-component-view-normal">
                  <MapComponent
                    dataLayer={dataLayer}
                    legendName={instanceLegendMap}
                    ubigeo={ubigeo}
                  />
                  <button
                    className="button-overmap-calcite"
                    onClick={me.handleClickLayerToogle}
                    title="Ver Capas"
                  ></button>
                  <div
                    className="map-component-layers"
                    style={{ display: showLayer ? "block" : "none" }}
                  >
                    {listLayer.length > 0 ? (
                      <ul>
                        {listLayer.map(function(item, key) {
                          return (
                            <li key={item.id} title={"Fuente: " + item.fuente}>
                              <div className="layer_content">
                                <input
                                  access={key}
                                  key={item.id}
                                  url={item.url}
                                  id={item.id}
                                  layer={item.layerName}
                                  layertype={item.type}
                                  visible={`${item.visible}`}
                                  label={item.label}
                                  link={item.link}
                                  defaultChecked={item.visible}
                                  ref="complete"
                                  type="checkbox"
                                  fuente={item.fuente}
                                  onChange={me.handleClickLayer}
                                />
                                <span className="layer_content_text">
                                  {item.label}
                                </span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div>
                        <ul>
                          <li>
                            <div className="layer_content">
                              <i className="fas fa-info-circle col-size-icon text-primary"></i>
                              <span className="layer_content_text">
                                No existe capas para mostrar
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                  <div className="control-panel shadow">
                    <ul className="control-panel__list">
                      <li
                        className="control-panel__share-map pointer"
                        title={showMenuLeft ? "Ampliar Mapa" : "Reducir Mapa"}
                        onClick={this.handleClickMenuLeft}
                      >
                        {showMenuLeft ? (
                          <SVGIcon id={"icon-map-zoom"} />
                        ) : (
                          <SVGIcon id={"icon-map-minus"} />
                        )}
                      </li>
                      <li
                        className="control-panel__share-map pointer"
                        title={"Ver Legenda"}
                        onClick={this.handleClickLayerLegend}
                      >
                        <SVGIcon id={"icon-legend"} />
                      </li>
                    </ul>
                  </div>
                  <div className="legend-panel">
                    <div
                      className="legend-panel__title"
                      onClick={this.handleClickLayerLegend}
                    >
                      <span>Leyenda</span>
                      <span
                        className="legend-panel__category-caret"
                        style={{ display: showLegend ? "block" : "none" }}
                      >
                        ▼
                      </span>
                      <span
                        className="legend-panel__category-caret"
                        style={{ display: showLegend ? "none" : "block" }}
                      >
                        ▲
                      </span>
                    </div>
                    <div
                      className="legend-panel__layers"
                      style={{ display: showLegend ? "block" : "none" }}
                    >
                      <div>
                        <MapLegend data={dataLegend} />
                        <div id={instanceLegendMap}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <SeccionDocumentos
          publicaciones={data_documento}
          normas={data_norma}
          marco={marco}
          ubigeo={ubigeo}
        />
      </div>
    );
  }
}

export default VistaTematicasAmbientales;
